export default __webpack_public_path__ + "static/detailImg1-ec155e2da4ed66cf0ab3e65a6b755738.webp";